export default __webpack_public_path__ + "static/media/eight.055ac6c9.svg";